import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fd3dadc4")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_openBlock(), _createBlock("span", {
    class: "back-button",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)), ["stop"]))
  }, [
    _createVNode(_component_fa_icon, { icon: "arrow-circle-left" })
  ]))
})